import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomButton from "../../common-components/button/Button.jsx";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "../../state/reducers/architectureConversion";
import Select from "../../common-components/select/Select.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

function ArchConfiguration() {
  const dispatch = useDispatch();
  const handleNext = () => {
    dispatch(setCurrentStep(5));
  };

  const handleBack = () => {
    dispatch(setCurrentStep(3));
  }

  return (
    <div className="page-wrapper database-conversion-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">
              Choose Configuration 
            </h2>
            <div className="arch-conversation-wrapper">
              <div className="arch-structure-wrapper">
                <div className="upload-structure-wrapper">
                  <h3 className="wrapper-title">Target Architecture</h3>
                  <Row className="mb-3">
                    <Col xs={6}>
                      Source Architecture
                    </Col>
                    <Col xs={6}>
                      Angular
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={6}>
                      Target Architecture
                    </Col>
                    <Col xs={6}>
                      React
                    </Col>
                  </Row>
                </div>
                <div className="export-structure-wrapper pb-100 position-relative">
                  <h3 className="wrapper-title">Target Configuration</h3>
                  <div className="config-list">
                    <Row className="mb-3">
                      <Col md={5}><h3 className="section-h3">Source Architecture</h3></Col>
                      <Col md={7}><h3 className="section-h3">Target Architecture</h3></Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <Select 
                          value={""} 
                          options={""} 
                          placeholder={"Inbuilt Router"} 
                          label="Inbuilt Router" 
                          id="source-language" 
                          disabled
                          // onChange={handleSourceLanguageChange}
                          layoutStyle="horizontal"
                          labelColSize={5}
                          inputColSize={7}
                          required
                          // validationMsg={errors.sourceLanguage}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <Select 
                          value={""} 
                          options={""} 
                          placeholder={"Styling Framework"} 
                          label="Styling Framework" 
                          id="target-language" 
                          disabled
                          // onChange={handleSourceLanguageChange}
                          layoutStyle="horizontal"
                          labelColSize={5}
                          inputColSize={7}
                          required
                          // validationMsg={errors.sourceLanguage}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Select 
                          value={""} 
                          options={""} 
                          placeholder={"React Form"} 
                          label="Form Builder" 
                          id="target-language" 
                          disabled
                          // onChange={handleSourceLanguageChange}
                          layoutStyle="horizontal"
                          labelColSize={5}
                          inputColSize={7}
                          required
                          // validationMsg={errors.sourceLanguage}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="add-package">
                    <span>Add Package</span> <FontAwesomeIcon icon={faPlus} />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-end">
            <CustomButton className="me-3" onClick={handleBack} label="Back" />
            <CustomButton onClick={handleNext} label="Next" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ArchConfiguration;